import * as React from "react";
import type { SVGProps } from "react";
const SvgMastercard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path fill="#ff5f00" d="M9.026 7.142h5.95v9.719h-5.95z" />
    <path
      fill="#eb001b"
      d="M9.639 12.002a6.17 6.17 0 0 1 2.36-4.858 6.18 6.18 0 1 0 0 9.718 6.17 6.17 0 0 1-2.36-4.86"
    />
    <path
      fill="#f79e1b"
      d="M22 12.002a6.18 6.18 0 0 1-10 4.859 6.18 6.18 0 0 0 0-9.72 6.18 6.18 0 0 1 10 4.86z"
    />
  </svg>
);
export default SvgMastercard;
